import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Award, Truck, Shield, Users, Star } from 'lucide-react';
import logo from '../assets/logo.png';

const About = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-[#2d3c5d] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <img src={logo} alt="Deco Home" className="h-32 mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Deco Home Sin Rival</h1>
          <p className="text-xl md:text-2xl font-light" style={{ color: '#eddacb' }}>
            Tu hogar merece lo mejor
          </p>
        </div>
      </section>

      {/* Nuestra Historia */}
      <section className="py-12">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
            <h2 className="text-3xl font-bold text-[#2d3c5d] mb-6 text-center">
              Sobre Nosotros
            </h2>
            <div className="text-gray-700 space-y-4 text-lg leading-relaxed">
              <p>
                Somos <strong>Deco Home Sin Rival</strong>, la tienda online especializada en decoración que trae a tu espacio estilo, calidez y diseño de vanguardia. Con la experiencia de Sin Rival, ofrecemos productos de calidad premium seleccionados para transformar cualquier espacio.
              </p>
              <p>
                Nuestro emprendimiento nace con foco en la decoración y ambientación de espacios, tomando inspiración del reconocido comercio multirubro Sin Rival. Nos especializamos en la venta mayorista y minorista online de productos de decoración importados directamente desde China, tales como plantas artificiales, paneles de revestimiento, alfombras, frazadas, espejos y mesas.
              </p>
              <p>
                Nuestra motivación es aprovechar la oportunidad de traer artículos importados directamente desde China que no se consiguen en la región, para ofrecer una propuesta innovadora y de calidad tanto a comercios que deseen revender como al público minorista.
              </p>
              <p>
                Somos <strong>innovadores, sofisticados, modernos, vanguardistas, accesibles y confiables</strong>. Trabajamos día a día para brindar la mejor experiencia de compra, desde la selección de productos exclusivos hasta la entrega en tu domicilio.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Nuestros Valores */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-[#2d3c5d] mb-12 text-center">
            Lo Que Nos Define
          </h2>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="text-center">
              <div className="w-20 h-20 bg-[#2d3c5d]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="w-10 h-10 text-[#2d3c5d]" />
              </div>
              <h3 className="text-xl font-bold text-[#2d3c5d] mb-3">Innovación</h3>
              <p className="text-gray-600">
                Traemos productos exclusivos y de vanguardia que no se consiguen en la región.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#2d3c5d]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-10 h-10 text-[#2d3c5d]" />
              </div>
              <h3 className="text-xl font-bold text-[#2d3c5d] mb-3">Calidad Premium</h3>
              <p className="text-gray-600">
                Importación directa desde China con excelente relación precio-calidad.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-[#2d3c5d]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-10 h-10 text-[#2d3c5d]" />
              </div>
              <h3 className="text-xl font-bold text-[#2d3c5d] mb-3">Accesibilidad</h3>
              <p className="text-gray-600">
                Atención personalizada tanto para mayoristas como minoristas, con confianza y transparencia.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Por qué elegirnos */}
      <section className="py-12">
        <div className="container mx-auto px-4 max-w-5xl">
          <h2 className="text-3xl font-bold text-[#2d3c5d] mb-12 text-center">
            Nuestras Ventajas
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2d3c5d]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Star className="w-6 h-6 text-[#2d3c5d]" />
                </div>
                <div>
                  <h3 className="font-bold text-[#2d3c5d] mb-2">Productos Exclusivos</h3>
                  <p className="text-gray-600 text-sm">
                    Importamos directamente desde China productos únicos que no se consiguen en tiendas de la región. Traemos lo último en decoración de vanguardia.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2d3c5d]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Award className="w-6 h-6 text-[#2d3c5d]" />
                </div>
                <div>
                  <h3 className="font-bold text-[#2d3c5d] mb-2">Excelente Relación Precio-Calidad</h3>
                  <p className="text-gray-600 text-sm">
                    Al importar directamente, ofrecemos productos de alta calidad a precios competitivos, sin intermediarios.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2d3c5d]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Users className="w-6 h-6 text-[#2d3c5d]" />
                </div>
                <div>
                  <h3 className="font-bold text-[#2d3c5d] mb-2">Para Mayoristas y Minoristas</h3>
                  <p className="text-gray-600 text-sm">
                    Atendemos tanto a comercios que desean revender como al público minorista. Experiencia adaptada a cada tipo de cliente.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-[#2d3c5d]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <Truck className="w-6 h-6 text-[#2d3c5d]" />
                </div>
                <div>
                  <h3 className="font-bold text-[#2d3c5d] mb-2">Retiro en Depósito</h3>
                  <p className="text-gray-600 text-sm">
                    Comprá online y retirá tus productos en nuestros depósitos. ¡Rápido, fácil y sin costo adicional!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 bg-[#2d3c5d]">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            ¿Listo para transformar tu hogar?
          </h2>
          <p className="text-xl mb-8" style={{ color: '#eddacb' }}>
            Explorá nuestro catálogo y encontrá los productos perfectos para vos
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/productos"
              className="inline-block px-8 py-3 rounded-lg font-semibold transition"
              style={{
                backgroundColor: '#eddacb',
                color: '#2d3c5d',
              }}
            >
              Ver productos
            </Link>
            <Link
              to="/contacto"
              className="inline-block px-8 py-3 rounded-lg font-semibold border-2 transition"
              style={{
                borderColor: '#eddacb',
                color: '#eddacb',
              }}
            >
              Contactanos
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
